/*
  industrialkonzept Next, 2026-09-23
  Homepage mode (magazine / shop), sticky buy bar on product pages, shop the story on articles.
  Every feature is optional: without this script the shop works as before.
*/
(() => {
  if (window.__ikNext) return;
  window.__ikNext = true;

  const T = (k, v) => (window.ikT ? window.ikT(k, v) : k);
  const root = document.documentElement;
  const template = root.getAttribute('data-ikn-template') || '';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const store = {
    get(key) {
      try {
        return localStorage.getItem(key);
      } catch (e) {
        return null;
      }
    },
    set(key, value) {
      try {
        localStorage.setItem(key, value);
      } catch (e) {
        /* private mode: the choice simply is not remembered */
      }
    },
  };

  /* ---------- Homepage mode ---------- */
  const pill = document.querySelector('[data-ikn-modepill]');
  const applyMode = (mode) => {
    if (mode !== 'shop') mode = 'magazine';
    root.setAttribute('data-ikn-mode', mode);
    document.querySelectorAll('[data-ikn-set-mode]').forEach((btn) => {
      btn.setAttribute('aria-pressed', String(btn.getAttribute('data-ikn-set-mode') === mode));
    });
  };
  if (pill) {
    // the theme editor always starts in magazine mode, so no section seems to be missing there
    applyMode((!(window.Shopify && window.Shopify.designMode) && store.get('ikn-mode')) || 'magazine');
    pill.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-ikn-set-mode]');
      if (!btn) return;
      const mode = btn.getAttribute('data-ikn-set-mode');
      store.set('ikn-mode', mode);
      applyMode(mode);
      window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
      window.dispatchEvent(new Event('resize'));
    });
    // The pill starts hidden (snippets/ik-mode-switch.liquid) and stays away near the footer,
    // so it never covers footer links. On phones it also waits until the first banner has been
    // scrolled past, so it never sits on the cover headline.
    const phone = window.matchMedia('(max-width: 767px)');
    let nearFooter = false;
    const firstBanner = () => {
      const first = [...document.querySelectorAll('#MainContent > .shopify-section')].find((s) => s.offsetHeight > 0);
      return first && (first.querySelector('.ikh-cover__bottom > :first-child') || first);
    };
    const place = () => {
      const banner = phone.matches && firstBanner();
      const onBanner = !!banner && banner.getBoundingClientRect().bottom > 0;
      pill.classList.toggle('is-hidden', nearFooter || onBanner);
    };
    let queued = false;
    const queue = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        place();
      });
    };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    const footer = document.querySelector('[id$="__footer"]');
    if (footer && 'IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          nearFooter = entry.isIntersecting;
          place();
        });
      }).observe(footer);
    }
    place();
  } else {
    root.removeAttribute('data-ikn-mode');
  }

  /* ---------- Sticky buy bar ---------- */
  const buybar = document.querySelector('[data-ikn-buybar]');
  if (buybar && template === 'product') {
    const mainBtn = document.querySelector('#MainContent .product-block-area .add-to-cart');
    const priceBlock = document.querySelector('#MainContent .product-block-area .product-price-block');
    const barBtn = buybar.querySelector('[data-ikn-buybar-btn]');
    const barPrice = buybar.querySelector('[data-ikn-buybar-price]');

    if (mainBtn && barBtn) {
      buybar.hidden = false;

      const sync = () => {
        // only the words the visitor sees: the theme's button also holds a hidden copy of its label
        // (for browsers without scripts), and textContent read both ("Add to cart Add to cart")
        const label = (mainBtn.innerText || mainBtn.textContent || '')
          .replace(/\s+/g, ' ')
          .trim()
          .replace(/^(.+?)(?: \1)+$/, '$1');
        if (label) barBtn.textContent = label;
        barBtn.disabled = mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true';
        if (priceBlock && barPrice) {
          const spans = [...priceBlock.querySelectorAll(':scope > span:not(.sr-only)')];
          const current = spans.length ? spans[spans.length - 1].textContent.trim() : '';
          if (current) barPrice.textContent = current;
        }
      };
      sync();
      const mo = new MutationObserver(sync);
      mo.observe(mainBtn, { attributes: true, childList: true, subtree: true, characterData: true });
      if (priceBlock) mo.observe(priceBlock, { childList: true, subtree: true, characterData: true });

      // The theme wakes the product form up only once it has been on screen.
      // If the visitor jumped past it, wake it first so the cart drawer opens as usual.
      // Should that take too long, add the item directly and open the drawer the theme's way.
      const island = mainBtn.closest('data-island[x-data]');
      const form = mainBtn.closest('form');
      const cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      const addDirectly = async () => {
        try {
          const res = await fetch(cartRoot + 'cart/add.js', {
            method: 'POST',
            body: new FormData(form),
            headers: { Accept: 'application/json' },
          });
          if (!res.ok) throw new Error('add failed');
          // the theme redraws the drawer lines, footer and count from these sections
          try {
            const sections = await (await fetch(cartRoot + '?sections=cart-items,cart-footer,cart-item-count,cart-live-region')).json();
            window.dispatchEvent(new CustomEvent('baseline:cart:update', { detail: { response: { sections } } }));
          } catch (e) {}
          document.dispatchEvent(new CustomEvent('theme:update:cart'));
          if (window.Alpine && window.Alpine.store && window.Alpine.store('modals')) {
            window.Alpine.store('modals').open('cart');
          }
        } catch (e) {
          form.submit();
        }
      };

      const whenReady = (cb) => {
        if (!island || island.hasAttribute('ready')) return cb(true);
        mainBtn.scrollIntoView({ block: 'center', behavior: 'auto' });
        let done = false;
        const finish = (ready) => {
          if (done) return;
          done = true;
          ro.disconnect();
          cb(ready);
        };
        const ro = new MutationObserver(() => island.hasAttribute('ready') && finish(true));
        ro.observe(island, { attributes: true, attributeFilter: ['ready'] });
        window.setTimeout(() => finish(island.hasAttribute('ready')), 1500);
      };

      barBtn.addEventListener('click', () => {
        if (barBtn.disabled) return;
        whenReady((ready) => (ready || !form ? mainBtn.click() : addDirectly()));
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            buybar.classList.toggle('is-on', past);
          });
        }).observe(mainBtn);
      }
    }
  }

  /* ---------- Gift collections by budget in the visitor's currency ----------
     The collections gifts-under-50 … -500 filter by the price in euros. Everywhere a link leads to one (menus,
     phone menu, homepage, chips) and on their own page (title and crumb, snippets/ik-gift-name.liquid), the
     name shows the limit in the currency the visitor shops in: converted with Shopify's rate and rounded
     UP to a round amount, so "under S$75" stays true for every product in it. In euros nothing changes. */
  (() => {
    const cur = window.Shopify && window.Shopify.currency;
    const active = (cur && cur.active) || 'EUR';
    const rate = parseFloat((cur && cur.rate) || '1') || 1;
    const nice = (x) => {
      if (x < 10) return Math.ceil(x);
      const m = Math.pow(10, Math.floor(Math.log10(x)));
      const steps = [1, 1.2, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 6, 7, 7.5, 8, 9, 10];
      return steps.find((s) => s * m >= x - 1e-9) * m;
    };
    const amountText = (eur) => {
      if (active === 'EUR') return T('gifts.eur', { amount: eur });
      const v = nice(eur * rate);
      // the shop's own money format for this currency (window.ikMoney, layout/theme.liquid), without cents
      return window.ikMoney ? window.ikMoney(v * 100).replace(/([.,]00)(?=\D*$)/, '') : v + ' ' + active;
    };
    const label = (eur) => T('gifts.under', { amount: amountText(eur) });
    const fix = () => {
      // the page's own title and crumb (already in the right words, only the amount may change)
      if (active !== 'EUR') document.querySelectorAll('[data-ikn-gift]:not([data-ikn-gift-done])').forEach((el) => {
        el.textContent = label(+el.getAttribute('data-ikn-gift'));
        el.setAttribute('data-ikn-gift-done', '');
      });
      // links: the text of the link itself (menus write their own names, which differ between languages)
      document.querySelectorAll('a[href*="/collections/gifts-under-"]:not([data-ikn-gift-done])').forEach((a) => {
        a.setAttribute('data-ikn-gift-done', '');
        const m = /\/collections\/gifts-under-(\d+)(?:[/?#]|$)/.exec(a.getAttribute('href') || '');
        if (!m) return;
        // the text node with the name (a chip or card keeps its other parts)
        const walker = document.createTreeWalker(a, NodeFilter.SHOW_TEXT, { acceptNode: (n) => (/\d/.test(n.nodeValue) && !n.parentElement.closest('.ikn-chip__n, .ikh-card__vendor') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP) });
        const node = walker.nextNode();
        if (!node) return;
        const lead = node.nodeValue.match(/^\s*/)[0];
        const tail = node.nodeValue.match(/\s*$/)[0];
        node.nodeValue = lead + label(+m[1]) + tail;
      });
    };
    fix();
    // the phone menu and other parts are drawn later: look again when something new appears
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        if (document.querySelector('a[href*="/collections/gifts-under-"]:not([data-ikn-gift-done]), [data-ikn-gift]:not([data-ikn-gift-done])')) fix();
      });
    }).observe(document.body, { childList: true, subtree: true });
  })();

  /* ---------- Shop the story on articles ---------- */
  const articleShop = document.querySelector('[data-ikn-articleshop]');
  if (articleShop && template === 'article') {
    const track = articleShop.querySelector('[data-ikn-articleshop-track]');
    const fromLabel = (articleShop.querySelector('[data-ikn-str-from]') || {}).textContent || T('next.from');
    const scope = document.querySelector('[data-ika-body]') || document.querySelector('#MainContent .shopify-section') || document;
    const handles = [];
    scope.querySelectorAll('a[href*="/products/"]').forEach((a) => {
      const match = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (match && !handles.includes(match[1])) handles.push(match[1]);
    });

    const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    // prices look exactly like the theme's (window.ikMoney, layout/theme.liquid)
    const money = { format: (units) => window.ikMoney(Math.round(units * 100)) };
    const esc = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const sized = (url, w) => (url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '');
    const fetchProduct = (h) =>
      fetch(base + 'products/' + h + '.js', { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : null))
        .catch(() => null);

    // No product links, but a brand in the title: put the brand's products named in the title first
    const brandName = (articleShop.getAttribute('data-ikn-brand') || '').trim();
    if (track && !handles.length && brandName) {
      const title = articleShop.getAttribute('data-ikn-title') || '';
      const words = [...new Set(title.split(/[\s,.:;!?"'’()]+/).filter((w) => w.length > 2 && /^\p{Lu}/u.test(w)))]
        .filter((w) => w.toLowerCase() !== brandName.toLowerCase() && !w.toLowerCase().startsWith(brandName.toLowerCase()))
        .slice(0, 5);
      Promise.all(
        words.map((w) =>
          fetch(base + 'search/suggest.json?q=' + encodeURIComponent(w) + '&resources[type]=product&resources[limit]=10')
            .then((r) => (r.ok ? r.json() : null))
            .catch(() => null)
        )
      ).then((results) => {
        // Keep only products whose name shares a word with the title, best matches first
        const stem = (w) => w.toLowerCase().replace(/s$/, '');
        const stems = words.map(stem);
        const scored = {};
        results.forEach((res) => {
          const list = (res && res.resources && res.resources.results && res.resources.results.products) || [];
          list.forEach((p) => {
            if ((p.vendor || '').toLowerCase() !== brandName.toLowerCase() || scored[p.handle]) return;
            const titleWords = (p.title || '').split(/[\s,.:;\-–()]+/).map(stem);
            const score = stems.filter((st) => titleWords.includes(st)).length;
            if (score > 0) scored[p.handle] = score;
          });
        });
        const found = Object.keys(scored).sort((x, y) => scored[y] - scored[x]);
        if (!found.length) return;
        const existing = new Set([...track.querySelectorAll('a.ikh-card')].map((a) => (a.getAttribute('href') || '').split('?')[0].split('/').pop()));
        Promise.all(found.filter((h) => !existing.has(h)).slice(0, 8).map(fetchProduct)).then((products) => {
          // ik-article.js fills the same rail: look again right before adding, so nothing shows twice
          const now = new Set([...track.querySelectorAll('a.ikh-card')].map((a) => (a.getAttribute('href') || '').split('?')[0].split('/').pop()));
          const html = products.filter((p) => p && !now.has(p.handle)).map(card).join('');
          if (html) {
            track.insertAdjacentHTML('afterbegin', html);
            track.scrollLeft = 0;
            window.dispatchEvent(new Event('resize'));
          }
        });
      });
    }

    function card(p) {
      const img = p.featured_image ? (p.featured_image.startsWith('//') ? 'https:' + p.featured_image : p.featured_image) : '';
      const alt = p.images && p.images[1] ? (p.images[1].startsWith('//') ? 'https:' + p.images[1] : p.images[1]) : '';
      const price = money.format(p.price_min / 100);
      // compare-at price = the maker's RRP, labelled as on the server cards (snippets/ik-home-card.liquid)
      const compare = p.compare_at_price_min > p.price_min && !p.price_varies ? '<span class="ikh-price__rrp">' + esc(T('product.rrp')) + ' <s>' + money.format(p.compare_at_price_min / 100) + '</s></span>' : '';
      // sold out as on the server cards (snippets/ik-home-card.liquid): grey name, "Sold out" instead of the price
      const sold = p.available === false;
      return (
        '<a class="ikh-card' + (sold ? ' is-sold' : '') + '" href="' + esc(base + 'products/' + p.handle) + '">' +
        '<div class="ikh-card__media">' +
        (img ? '<img src="' + esc(sized(img, 720)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
        (alt ? '<img class="ikh-card__alt" src="' + esc(sized(alt, 720)) + '" alt="" loading="lazy">' : '') +
        '</div><div class="ikh-card__meta"><span class="ikh-card__vendor">' + esc(p.vendor) + '</span>' +
        '<span class="ikh-card__title">' + esc(p.title) + '</span>' +
        (sold
          ? '<span class="ikh-card__sold">' + esc(T('lab.sold_out')) + '</span>'
          : '<span class="ikh-price"><span>' + (p.price_varies ? esc(fromLabel) + ' ' : '') + price + '</span>' + compare + '</span>') +
        '</div></a>'
      );
    }

    // Products chosen for the article (content.products) are already in the rail: keep them first, add the rest
    const picked = articleShop.hasAttribute('data-ikn-articleshop-picked');
    if (track && handles.length) {
      const have = new Set([...track.querySelectorAll('a.ikh-card')].map((a) => (a.getAttribute('href') || '').split('?')[0].split('/').pop()));
      Promise.all(handles.filter((h) => !picked || !have.has(h)).slice(0, 12).map(fetchProduct)).then((products) => {
        const cards = products
          .filter(Boolean)
          .map(card);
        if (!cards.length) return;
        if (picked) track.insertAdjacentHTML('beforeend', cards.join(''));
        else track.innerHTML = cards.join('');
        const title = articleShop.querySelector('[data-ikn-articleshop-title]');
        if (title) title.textContent = title.getAttribute('data-ikn-title-links') || title.textContent;
        const all = articleShop.querySelector('[data-ikn-articleshop-all]');
        if (all) all.remove();
        articleShop.hidden = false;
        window.dispatchEvent(new Event('resize'));
      });
    }
  }
})();
